// src/routes/RecruiterRoutes.tsx
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';
import adminRoutesConfig from './config/adminRoutesConfig';


const AdminRoutes = adminRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}>
        <ProtectedRoute element={<Component />} allowedRoles={['Admin', 'HR', 'Accountant']} />
      </Suspense>
    }
  />
));
export default AdminRoutes;

